import type { Payment } from 'paintscout'
import { getRefundableAmount } from './get-refundable-amount'

/**
 * Whether a payment can be refunded from the UI.
 *
 * Refunds are only supported for manual payments and payrix - not stripe. The payment must be a
 * recorded ('paid') payment with a refundable balance remaining. Requiring 'paid' also excludes
 * pending/processing/failed payments and refund rows themselves (which are stored as 'refunded').
 */
export function canRefundPayment(payment: Payment, allPayments: Payment[]): boolean {
  if (!payment?.activityId) return false
  if (!payment.manual && payment.provider !== 'payrix') return false
  if (payment.status !== 'paid') return false
  return getRefundableAmount(payment, allPayments) > 0
}
